<div class="container-fluid reset_password_container">
	<input type="hidden" id="anPageName" name="page" value="reset-password-3" />
	<div class="row">
		<div class="col-12">
			<div class="header">
				<img class="image-11" src="../assets/newimg/image-11-86@2x.png" alt="image 11" />
				<div class="flex-col">
					<div class="overlap-group-1">
						<p class="surname opensans-bold-sapphire-20px">
							<span class="opensans-normal-sapphire-20px">Cross</span>
							<span class="ellipsis"></span>
							<span class="opensans-extra-bold-sapphire-20px">Easy</span>
						</p>
					</div>
					<p class="brought-to-you-by-cr opensans-normal-star-dust-9px">
						<span class="opensans-normal-star-dust-9px">
							Brought to you by Cross-Border Road and Transport
							Agency
						</span>
					</p>
				</div>
			</div>
		</div>
	</div>
	<div class="row content_row">
		<div class="col-8">
			<form class="reset_form">
				<div class="heading">
					<h1>Forgot Password</h1>
					<p class="subheading">A verification link will be sent to you.</p>
				</div>
				<p class="please-provide-us">
					Please provide us with your
					email/ mobile
					number to receive a reset password link to your
					preferred communication method to verify and complete the reset password
					process.
				</p>

				<div class="row form_row">
					<div class="col-6">
						<div class="email-address form_field">
							<label class="label">Email Address <a class="red-asterik">*</a></label>
							<input type="email" name="EmailAddress" class="form-field input-sm"
								placeholder="Please enter your email" name="EmailAddress"
								[(ngModel)]="loginUser.EmailAddress" #emailref="ngModel" required />
							<div *ngIf="emailref.errors && (emailref.touched || emailref.dirty)" class="error_message">
								Enter a valid email address
							</div>

						</div>
					</div>
					<div class="col-6">
						<div class="mobile-number form_field">
							<label class="label">Mobile Number <a class="red-asterik">*</a> </label>
							<ngx-intl-tel-input [cssClass]="'form-field input-sm'"
								[preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
								[enablePlaceholder]="true" [searchCountryFlag]="true"
								[searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
								[selectFirstCountry]="false" [maxLength]="15" [tooltipField]="TooltipLabel.Name"
								[phoneValidation]="true" [selectedCountryISO]="defaultCountry"
								[separateDialCode]="separateDialCode" (countryChange)="ChangeCountry($event)"
								name="MobileNumber" [(ngModel)]="loginUser.MobileNumber" #emailref="ngModel">
							</ngx-intl-tel-input>
							<div *ngIf="emailref.errors && (emailref.touched || emailref.dirty)" class="error_message">
								Enter a valid mobile number
							</div>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-12 primary">
						<div class="send-link">
							<button class="btn btn-outline-warning" (click)="resetPassword()">Send
								Link</button>
						</div>
					</div>
				</div>
			</form>
		</div>

		<div class="col-4 parent">
			<div class="parents">
				<div class="overlap_group">
					<div class="surname">
						<span class="cross">Cross</span>
						<span class="ellipsis"></span>
						<span class="easy">Easy</span>
						<div class="here-there-everywhere">
							<span class="opensans-normal-white-16px">Here, There, Everywhere</span>
						</div>
					</div>
				</div>
				<div class="convenient-effectiv">
					<p>Convenient, Effective and</p>
					<p>Secure way to apply and</p>
					<p>manage your Permits</p>
					<p>Online</p>
				</div>
			</div>
		</div>

	</div>

</div>